export default __webpack_public_path__ + "20f389c4120be058d80a3cd6a2f5a9b9.woff2";